(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pivoli-bundle-engine"] && !Shopify.designMode) return;
  try {
    class PivoliBundleMath {
    static rate(count, active) { return active ? count >= 3 ? 10 : count >= 2 ? 5 : 0 : 0; }
    static rows(inputs) {
      return Array.from(inputs).map(input => {
        const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        return { id: String(input.value), quantity: 1, price: Number(option?.dataset.price || 0), available: option?.dataset.available !== 'false', tracked: option?.dataset.tracked === 'true', stock: Number(option?.dataset.stock || 0) };
      });
    }
    static merge(rows) {
      const grouped = new Map();
      for (const row of rows) {
        const current = grouped.get(row.id);
        if (current) current.quantity += row.quantity;
        else grouped.set(row.id, { ...row });
      }
      return [...grouped.values()];
    }
    static totals(rows, active) {
      const merged = this.merge(rows);
      const count = merged.reduce((sum, row) => sum + row.quantity, 0);
      const rate = this.rate(count, active);
      const regular = merged.reduce((sum, row) => sum + row.price * row.quantity, 0);
      const discount = merged.reduce((sum, row) => sum + Math.floor(row.price * rate / 100) * row.quantity, 0);
      return { count, rate, regular, price: regular - discount };
    }
    static inStock(rows) {
      return rows.length > 0 && this.merge(rows).every(row => row.id && row.available && (!row.tracked || row.quantity <= row.stock));
    }
    static money(amount, currency) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(amount / 100);
    }
  }

  class PivoliQuantityBundle extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.formComponent = this.closest('product-form');
      this.tiers = [...this.querySelectorAll('[data-quantity]')];
      this.activeDiscounts = this.dataset.discountsActive === 'true';
      this.addEventListener('change', event => {
        if (event.target.type === 'radio') {
          const previousInputs = this.selectedTier?.querySelectorAll('[data-bundle-variant]');
          const previousValues = previousInputs ? [...previousInputs].map(input => input.value) : [];
          this.selectedTier = event.target.closest('[data-quantity]');
          this.selectedTier.querySelectorAll('select[data-bundle-variant]').forEach((input, index) => {
            const candidate = previousValues[index] || previousValues[0];
            if ([...input.options].some(option => option.value === candidate && !option.disabled)) input.value = candidate;
          });
        }
        this.refresh();
        const selectedInput = event.target.matches('select[data-bundle-variant]') ? event.target : this.selectedTier.querySelector('[data-bundle-variant]');
        if (selectedInput) this.updateVariantGallery(selectedInput.value);
      }, { signal: this.controller.signal });
      this.selectedTier = this.querySelector('input[type=radio]:checked').closest('[data-quantity]');
      customElements.whenDefined('product-form').then(() => {
        if (!this.isConnected) return;
        this.formComponent.quantityBreaks = this;
        this.dataset.ready = 'true';
        this.hidden = false;
        this.refresh();
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.mediaRequest?.abort(); this.controller = null; }
    async updateVariantGallery(variantId) {
      const section = this.closest('.shopify-section');
      const gallery = section?.querySelector('product-media-gallery');
      if (!gallery || !this.dataset.productUrl) return;
      this.mediaRequest?.abort();
      const request = new AbortController();
      this.mediaRequest = request;
      this.galleryCache ||= new Map();
      try {
        let html = this.galleryCache.get(variantId);
        if (!html) {
          const url = new URL(this.dataset.productUrl, window.location.origin);
          url.searchParams.set('variant', variantId);
          url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) return;
          html = await response.text();
          this.galleryCache.set(variantId, html);
        }
        if (request.signal.aborted || !this.isConnected) return;
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('product-media-gallery slider-component');
        const current = gallery.querySelector('slider-component');
        if (next && current) current.replaceWith(next);
        if (Number(this.selectedTier.dataset.quantity) === 1) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          history.replaceState(history.state, '', url);
        }
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Pivoli variant image could not be refreshed.');
      }
    }
    tierRows(tier = this.selectedTier) { return PivoliBundleMath.rows(tier.querySelectorAll('[data-bundle-variant]')); }
    refresh() {
      for (const tier of this.tiers) {
        const selected = tier === this.selectedTier;
        tier.querySelector('.pv-bundle-options').hidden = !selected;
        tier.querySelectorAll('select').forEach(input => { input.disabled = !selected; });
        tier.querySelectorAll('pivoli-variant-buttons').forEach(picker => picker.sync?.());
        const total = PivoliBundleMath.totals(this.tierRows(tier), this.activeDiscounts);
        tier.querySelector('[data-bundle-price]').textContent = PivoliBundleMath.money(total.price, this.dataset.currency);
        const regular = tier.querySelector('[data-bundle-regular]');
        regular.hidden = !total.rate;
        regular.textContent = PivoliBundleMath.money(total.regular, this.dataset.currency);
      }
      const hiddenId = this.formComponent.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = this.tierRows()[0].id;
      this.reportValidity();
      this.dispatchEvent(new CustomEvent('quantity-breaks:updated', { bubbles: true }));
    }
    reportValidity() {
      const valid = PivoliBundleMath.inStock(this.tierRows());
      const error = this.querySelector('[data-bundle-error]');
      error.hidden = valid;
      error.textContent = valid ? '' : this.dataset.stockError;
      const button = this.formComponent.querySelector('[data-ref="add-to-cart-button"]');
      if (button && !this.formComponent.isSubmitting) button.disabled = !valid;
      return valid;
    }
    isActive() { return this.dataset.ready === 'true'; }
    isVariantSelectorActivated() { return true; }
    getSelectedQuantity() { return this.selectedTier; }
    getSelectedItems() { return PivoliBundleMath.merge(this.tierRows()).map(({ id, quantity }) => ({ id, quantity })); }
    getPrices() {
      const total = PivoliBundleMath.totals(this.tierRows(), this.activeDiscounts);
      return { price: total.price, compareAtPrice: total.regular };
    }
    getDiscount() { return { type: 'percentage', percentage: PivoliBundleMath.rate(Number(this.selectedTier.dataset.quantity), this.activeDiscounts), value: 0 }; }
    getCrossSellPrices() { return { price: 0, compareAtPrice: 0 }; }
  }

  class PivoliBoughtTogether extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.button = this.querySelector('[data-fbt-add]');
      this.message = this.querySelector('[data-fbt-message]');
      this.addEventListener('change', () => this.refresh(), { signal: this.controller.signal });
      this.button.addEventListener('click', () => this.addSelected(), { signal: this.controller.signal });
      this.hidden = false;
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    rows() {
      return [...this.querySelectorAll('[data-fbt-card]')].filter(card => card.querySelector('[data-fbt-check]').checked).flatMap(card => PivoliBundleMath.rows(card.querySelectorAll('[data-fbt-variant]')));
    }
    refresh() {
      for (const card of this.querySelectorAll('[data-fbt-card]')) {
        const row = PivoliBundleMath.rows(card.querySelectorAll('[data-fbt-variant]'))[0];
        card.querySelector('[data-fbt-item-price]').textContent = PivoliBundleMath.money(row.price, this.dataset.currency);
      }
      const total = PivoliBundleMath.totals(this.rows(), this.dataset.discountsActive === 'true');
      this.querySelector('[data-fbt-total]').textContent = PivoliBundleMath.money(total.price, this.dataset.currency);
      const regular = this.querySelector('[data-fbt-regular]');
      regular.textContent = PivoliBundleMath.money(total.regular, this.dataset.currency);
      regular.hidden = !total.rate;
      this.button.disabled = this.pending || total.count === 0;
      this.message.textContent = total.count === 0 ? this.dataset.emptyMessage : '';
    }
    async addSelected() {
      const rows = this.rows();
      if (this.pending || !rows.length) return;
      this.pending = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.loadingLabel;
      this.message.textContent = '';
      let added = false;
      try {
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.dataset.sectionId ? [drawer.dataset.sectionId] : [];
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: PivoliBundleMath.merge(rows).map(({ id, quantity }) => ({ id, quantity })), sections, sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorMessage);
        added = true;
        if (!drawer) {
          this.message.textContent = this.dataset.successMessage;
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          const cartCount = document.querySelector('[data-pivoli-cart] b');
          if (cartCount) cartCount.textContent = String(cart.item_count);
          const hasDrawerSection = !drawer || Boolean(result.sections?.[drawer.dataset.sectionId]);
          if (hasDrawerSection) {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: cart, data: { itemCount: cart.item_count, source: 'pivoli-bought-together', sections: result.sections || {} } } }));
            if (drawer) document.dispatchEvent(new CustomEvent('cart:open'));
          }
        }
        this.message.textContent = this.dataset.successMessage;
      } catch (error) {
        this.message.textContent = added ? this.dataset.successMessage : (error.message || this.dataset.errorMessage);
      } finally {
        this.pending = false;
        this.removeAttribute('aria-busy');
        this.button.textContent = this.dataset.buttonLabel;
        this.button.disabled = this.rows().length === 0;
      }
    }
  }
  if (!customElements.get('pivoli-quantity-bundle')) customElements.define('pivoli-quantity-bundle', PivoliQuantityBundle);
  if (!customElements.get('pivoli-bought-together')) customElements.define('pivoli-bought-together', PivoliBoughtTogether);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pivoli-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
 const select=event.target.closest('.pv-card-select');if(!select)return;
 const card=select.closest('.pv-product-card'),option=select.selectedOptions[0];if(!option)return;
 card.querySelector('[data-pv-card-price]').textContent=option.dataset.money;
 const compare=card.querySelector('[data-pv-card-compare]');compare.textContent=option.dataset.compareMoney;compare.hidden=Number(option.dataset.compare)<=Number(option.dataset.price);
 card.querySelectorAll('.pv-product-photo,.pv-product-name').forEach(link=>{link.href=option.dataset.url;});
 const image=card.querySelector('.pv-product-photo img');
 if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.imageAlt||'';}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pivoli-variant-buttons"] && !Shopify.designMode) return;
  try {
    class PivoliVariantButtons extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.controller = new AbortController();
      this.group = this.querySelector('.pv-variant-buttons') || document.createElement('div');
      this.group.className = 'pv-variant-buttons';
      this.group.setAttribute('role', 'group');
      const label = [...this.select.labels].map(item => item.textContent.trim()).join(' ');
      if (label) this.group.setAttribute('aria-label', label);
      this.group.replaceChildren(...[...this.select.options].map(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pv-variant-button';
        button.dataset.value = option.value;
        button.textContent = option.textContent.trim();
        return button;
      }));
      this.append(this.group);
      this.group.addEventListener('click', event => {
        const button = event.target.closest('.pv-variant-button');
        if (!button || button.disabled || this.select.disabled) return;
        const option = [...this.select.options].find(item => item.value === button.dataset.value);
        if (!option || option.disabled) return;
        this.select.value = option.value;
        this.sync();
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: this.controller.signal });
      this.select.addEventListener('change', () => this.sync(), { signal: this.controller.signal });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.select, { attributes: true, subtree: true, attributeFilter: ['disabled', 'selected'] });
      this.dataset.ready = 'true';
      this.sync();
    }
    sync() {
      if (!this.group || !this.select) return;
      for (const button of this.group.children) {
        const option = [...this.select.options].find(item => item.value === button.dataset.value);
        button.disabled = this.select.disabled || !option || option.disabled;
        button.setAttribute('aria-pressed', String(this.select.value === button.dataset.value));
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  }
  if (!customElements.get('pivoli-variant-buttons')) customElements.define('pivoli-variant-buttons', PivoliVariantButtons);
  } catch(e) { console.error(e); }
})();

})();
